import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.asignadorFuncion.fields.id'),
  },
  {
    name: 'meta',
    label: i18n('entities.asignadorFuncion.fields.meta'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'nombreFuncion',
    label: i18n('entities.asignadorFuncion.fields.nombreFuncion'),
  },
  {
    name: 'empleados',
    label: i18n('entities.asignadorFuncion.fields.empleados'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'funcion',
    label: i18n('entities.asignadorFuncion.fields.funcion'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.asignadorFuncion.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.asignadorFuncion.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
